export default __webpack_public_path__ + "static/media/Mark-5-HUD-Pop-Up (Stats).d258aeef.jpg";